<template>
  <div>
    <b-card class="schedule">
      <div class="schedule_cards">
        <div class="schedule_cards-title">
          <validation-observer ref="simpleRules">
            <b-row>
              <b-col xs="12" :sm="services.length > 0 ? '6' : '12'">
                <validation-provider
                  name="schedule"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <Select2
                      :placeholder="$t('selectSchedule')"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      v-model="schedule_selected"
                      :options="schedules"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xs="12" sm="6" v-if="services.length > 0 ? true : false">
                <validation-provider
                  name="services"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group :class="{ 'has-error': errors.length > 0 }">
                    <Select2
                      placeholder="Please select type of services"
                      v-model="services_selected"
                      :options="services"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row> </b-row>
            <b-row>
              <b-col xs="12" sm="6">
                <!-- password -->
                <b-form-group>
                  <label> {{ $t("originStation") }} </label>
                  <Select4
                    v-model="columnFilters.pol_code"
                    placeholder="POL"
                    @select="({ name }) => (columnFilters.pol = name)"
                    :options="{
                      value: 'code',
                      label: 'name',
                      data: ports,
                      fields: [
                        { field: 'code', label: 'Code' },
                        { field: 'name', label: 'Name' },
                        { field: 'type', label: 'Service' },
                        {
                          field: 'country_code',
                          label: 'Country Code',
                        },
                      ],
                    }"
                  />
                </b-form-group>
              </b-col>
              <b-col xs="12" sm="6">
                <!-- password -->
                <b-form-group>
                  <label>{{ $t("destinationStation") }}</label>
                  <Select4
                    v-model="columnFilters.pod_code"
                    @select="({ name }) => (columnFilters.pod = name)"
                    placeholder="POD"
                    :options="{
                      value: 'code',
                      label: 'name',
                      data: ports,
                      fields: [
                        { field: 'code', label: 'Code' },
                        { field: 'name', label: 'Name' },
                        { field: 'type', label: 'Service' },
                        {
                          field: 'country_code',
                          label: 'Country Code',
                        },
                      ],
                    }"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="12" sm="6">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label> {{ $t("fromDate") }}</label>
                    <date-picker
                      ref="datePicker"
                      v-model="columnFilters.from_date"
                      type="date"
                      class="w-full"
                      value-type="format"
                      title-format="DD/MM/YY"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      time-title-format="DD/MM/YY"
                      placeholder="Select date"
                      :show-time-panel="showTimePanel"
                      format="DD/MM/YY"
                      @close="handleOpenChange"
                    >
                    </date-picker>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col xs="12" sm="6">
                <validation-provider #default="{ errors }" rules="">
                  <b-form-group>
                    <label> {{ $t("toDate") }}</label>
                    <date-picker
                      ref="datePicker"
                      v-model="columnFilters.to_date"
                      type="date"
                      class="w-full"
                      value-type="format"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      title-format="DD/MM/YY"
                      time-title-format="DD/MM/YY"
                      placeholder="Select date"
                      :show-time-panel="showTimePanel"
                      format="DD/MM/YY"
                      @close="handleOpenChange"
                    >
                    </date-picker>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>

          <b-row class="px-3 pb-3">
            <b-col cols="12" class="text-center">
              <button
                type="button"
                class="btn btn-success"
                @click="getSchedule"
              >
                <feather-icon icon="SearchIcon" class="cursor-pointer" />
                {{ $t("search") }}
              </button>
            </b-col>
          </b-row>
          <b-row class="pt-2">
            <b-col cols="12">
              <vue-good-table
                v-if="fields.length > 0"
                :columns="fields"
                :rows="schedule_list"
                :line-numbers="true"
              >
                <template slot="table-row" slot-scope="props">
                  <!-- Column: Action -->
                  <span v-if="props.column.field === 'action'">
                    <b-button
                    v-if="customerLevelId && customerLevelId.toString() == $Utils.VIP" 
                      variant="primary"
                      size="sm"
                      @click="onUserBooking(props.row)"
                    >
                      Booking
                    </b-button>
                    <b-button
                      variant="primary"
                      size="sm"
                      v-if="getWr1() && props.row.service_type_id == 3"
                      class="btn"
                      v-b-tooltip.hover.top="'Booking'"
                      @click="onHandlerBooking(props)"
                    >
                      <feather-icon icon="CheckIcon" />
                    </b-button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
    <ScheduleListBooking
      v-model="valueModal"
      :key="valueModal"
      :currentItem="currentItem"
    />

    <b-modal
      v-model="modalShow"
      hide-footer
      size="xl"
      scrollable
      body-class="body-class"
      title="New Booking"
    >
      <b-card-text>
        <request-quotation
          :isCustomer="true"
          :readonly="false"
          :view_RequestQuotation="request_quotation"
          step="booking"
          :readonlyService="true"
          @sendRequestBookingEvent="modalShow = false"
        />
      </b-card-text>

      <div
        class="d-flex justify-content-center flex-wrap px-2 pt-2 border-dr-top"
      ></div>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import Select2 from "v-select2-component";

import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
  BFormCheckbox,
  BFormGroup,
  VBTooltip,
  BFormSelect,
  BFormDatepicker,
  BFormRadioGroup,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { VueGoodTable } from "vue-good-table";
import "@core/scss/vue/libs/vue-good-table.scss";
import { mapState, mapActions } from "vuex";
import RequestQuotation from "@/views/wr1/quotation/RequestQuotation.vue";
import ScheduleListBooking from "@/views/wr1/schedule-list/ScheduleListBooking.vue";
import moment from "moment";
export default {
  components: {
    RequestQuotation,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    Select2,
    VueGoodTable,
    BFormSelect,
    BFormDatepicker,
    BFormRadioGroup,
    BFormInvalidFeedback,
    ScheduleListBooking,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      step: { default: null },
      customerLevelId: JSON.parse(localStorage.getItem("userData"))?.customerLevelId || null,

      valueModal: false,
      showTimePanel: false,
      currentItem: {},
      columnFilters: {},
      userData: JSON.parse(localStorage.getItem("userData")),
      schedule_selected: "SEA",
      services_selected: "LCL",
      modalShow: false,
      schedules: [
        { id: "SEA", text: "Sea" },
        { id: "AIR", text: "Air" },
        { id: "DOMESTIC", text: "Domestic" },
      ],
      services: [
        { id: "LCL", text: "LCL SCHEDULE" },
        { id: "FCL", text: "FCL SCHEDULE" },
      ],
      pol: "",
      pod: "",
      selected_radios: "",
      options_radios: [
        { text: "Choose from list Approved Quotation", value: 0 },
        { text: "New Quotation", value: 1 },
      ],
      polList: [],
      podList: [],

      services_options: {
        SEA: [
          { id: "LCL", text: "LCL SCHEDULE" },
          { id: "FCL", text: "FCL SCHEDULE" },
        ],
        DOMESTIC: [
          { id: "FTL", text: "FTL SCHEDULE" },
          { id: "LTL", text: "LTL SCHEDULE" },
        ],
        AIR: [],
      },
      constantsType: {
        LCL: "LCL",
        FCL: "FCL",
        FTL: "Container Trucking",
        LTL: "Van Trucking",
        AIR: "AIR",
      },
      schedule_list: [],
      request_quotation: {},
      fields: [],
      fields_all: {
        AIR: [
          {
            label: "POL",
            thClass: "text-uppercase align-middle",
            field: "pol",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "POL",
            },
          },
          {
            label: "POD",
            field: "pod",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "POD",
            },
          },
          {
            label: "LINE",
            thClass: "text-uppercase align-middle",
            field: "carrier",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "CARRIER",
            },
          },
          {
            label: "ETD",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "etd",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "eta",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "TRANSIT TIME",
            tdClass: "align-middle text-center",

            field: "transit_time",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT TIME",
            },
          },
          {
            label: "CARGO CUT OFF",
            tdClass: "align-middle text-center",

            field: "cargo_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "CARGO CUT OFF",
            },
          },
          {
            label: "DOC CUT OFF",
            tdClass: "align-middle ",

            field: "doc_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "DOC CUT OFF",
            },
          },
          {
            label: "TRANSIT PORT",
            tdClass: "align-middle text-center",

            field: "transit",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT PORT",
            },
          },
          {
            thClass: "text-uppercase align-middle",
            label: "Action",
            tdClass: "align-middle text-center",

            field: "action",
          },
        ],
        LCL: [
          {
            label: "POL",
            thClass: "text-uppercase align-middle",
            field: "pol",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "POL",
            },
          },
          {
            label: "POD",
            field: "pod",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "POD",
            },
          },
          {
            label: "LINE",
            thClass: "text-uppercase align-middle",
            field: "carrier",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "CARRIER",
            },
          },
          {
            label: "ETD",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "etd",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "eta",
            filterOptions: {
              enabled: false,
              placeholder: "ETA",
            },
          },
          {
            label: "TRANSIT TIME",
            tdClass: "align-middle text-center",

            field: "transit_time",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT TIME",
            },
          },

          {
            label: "CARGO CUT OFF",
            tdClass: "align-middle text-center",

            field: "cargo_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "CARGO CUT OFF",
            },
          },
          {
            label: "DOC CUT OFF",
            tdClass: "align-middle text-center",

            field: "doc_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "DOC CUT OFF",
            },
          },
          {
            label: "TRANSIT PORT",
            tdClass: "align-middle text-center",

            field: "transit",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT PORT",
            },
          },

          {
            thClass: "text-uppercase align-middle",
            label: "Action",
            tdClass: "align-middle text-center",

            field: "action",
          },
        ],
        FCL: [
          {
            label: "POL",
            thClass: "text-uppercase align-middle",
            field: "pol",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "POL",
            },
          },
          {
            label: "POD",
            field: "pod",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "POD",
            },
          },
          {
            label: "LINE",
            thClass: "text-uppercase align-middle",
            field: "carrier",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "CARRIER",
            },
          },
          {
            label: "ETD",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "etd",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "eta",
            filterOptions: {
              enabled: false,
              placeholder: "ETA",
            },
          },
          {
            label: "TRANSIT TIME",
            tdClass: "align-middle text-center",

            field: "transit_time",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT TIME",
            },
          },
          {
            label: "CARGO CUT OFF",
            tdClass: "align-middle text-center",

            field: "cargo_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "CARGO CUT OFF",
            },
          },
          {
            label: "DOC CUT OFF",
            tdClass: "align-middle text-center",

            field: "doc_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "DOC CUT OFF",
            },
          },
          {
            label: "TRANSIT PORT",
            tdClass: "align-middle text-center",

            field: "transit",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT PORT",
            },
          },
          {
            thClass: "text-uppercase align-middle",
            label: "Action",
            tdClass: "align-middle text-center",

            field: "action",
          },
        ],
        FTL: [
          {
            label: "POL",
            thClass: "text-uppercase align-middle",
            field: "pol",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "POL",
            },
          },
          {
            label: "POD",
            field: "pod",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "POD",
            },
          },
          {
            label: "ETD",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "etd",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "eta",
            filterOptions: {
              enabled: false,
              placeholder: "ETA",
            },
          },
          {
            label: "TRANSIT TIME",
            tdClass: "align-middle text-center",

            field: "transit_time",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT TIME",
            },
          },
          {
            label: "CARGO CUT OFF",
            tdClass: "align-middle text-center",

            field: "cargo_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "CARGO CUT OFF",
            },
          },
          {
            label: "DOC CUT OFF",
            tdClass: "align-middle text-center",

            field: "doc_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "DOC CUT OFF",
            },
          },
          {
            label: "TRANSIT PORT",
            tdClass: "align-middle text-center",

            field: "transit",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT PORT",
            },
          },
          {
            thClass: "text-uppercase align-middle",
            label: "Action",
            tdClass: "align-middle text-center",

            field: "action",
          },
        ],
        SEA_LTL: [
          {
            label: "POL",
            thClass: "text-uppercase align-middle",
            field: "pol",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "POL",
            },
          },
          {
            label: "POD",
            field: "pod",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "POD",
            },
          },
          {
            label: "ETD",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "etd",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "eta",
            filterOptions: {
              enabled: false,
              placeholder: "ETA",
            },
          },
          {
            label: "TRANSIT TIME",
            tdClass: "align-middle text-center",

            field: "transit_time",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT TIME",
            },
          },
          {
            label: "Vessel",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "load_vessel",
            filterOptions: {
              enabled: false,
              placeholder: "Vessel",
            },
          },

          {
            label: "CARGO CUT OFF",
            tdClass: "align-middle text-center",

            field: "cargo_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "CARGO CUT OFF",
            },
          },
          {
            label: "DOC CUT OFF",
            tdClass: "align-middle text-center",

            field: "doc_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "DOC CUT OFF",
            },
          },
          {
            label: "STUFFING PLACE",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "stuffing_place",
            width: "200px",
            filterOptions: {
              enabled: false,
              placeholder: "STUFFING PLACE",
            },
          },
          {
            thClass: "text-uppercase align-middle",
            label: "Action",
            tdClass: "align-middle text-center",

            field: "action",
          },
        ],
        LTL: [
          {
            label: "POL",
            thClass: "text-uppercase align-middle",
            field: "pol",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "POL",
            },
          },
          {
            label: "POD",
            field: "pod",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "POD",
            },
          },
          {
            label: "ETD",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "etd",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "eta",
            filterOptions: {
              enabled: false,
              placeholder: "ETA",
            },
          },
          {
            label: "TRANSIT TIME",
            tdClass: "align-middle text-center",

            field: "transit_time",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT TIME",
            },
          },
          {
            label: "CARGO CUT OFF",
            tdClass: "align-middle text-center",

            field: "cargo_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "CARGO CUT OFF",
            },
          },
          {
            label: "DOC CUT OFF",
            tdClass: "align-middle text-center",

            field: "doc_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "DOC CUT OFF",
            },
          },
          {
            label: "STUFFING PLACE",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "stuffing_place",
            width: "200px",
            filterOptions: {
              enabled: false,
              placeholder: "STUFFING PLACE",
            },
          },
          {
            thClass: "text-uppercase align-middle",
            label: "Action",
            tdClass: "align-middle text-center",

            field: "action",
          },
        ],
        SEA_FCL: [
          {
            label: "POL",
            thClass: "text-uppercase align-middle",
            field: "pol",
            tdClass: "align-middle text-center",

            filterOptions: {
              enabled: false,
              placeholder: "POL",
            },
          },
          {
            label: "POD",
            field: "pod",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "POD",
            },
          },
          {
            label: "ETD",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "etd",
            filterOptions: {
              enabled: false,
              placeholder: "ETD",
            },
          },
          {
            label: "ETA",
            tdClass: "align-middle text-center",

            thClass: "text-uppercase align-middle",
            field: "eta",
            filterOptions: {
              enabled: false,
              placeholder: "ETA",
            },
          },
          {
            label: "TRANSIT TIME",
            tdClass: "align-middle text-center",

            field: "transit_time",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT TIME",
            },
          },
          {
            label: "CARGO CUT OFF",
            tdClass: "align-middle text-center",

            field: "cargo_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "CARGO CUT OFF",
            },
          },
          {
            label: "DOC CUT OFF",
            tdClass: "align-middle text-center",

            field: "doc_cut_off",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "DOC CUT OFF",
            },
          },
          {
            label: "TRANSIT PORT",
            tdClass: "align-middle text-center",

            field: "transit",
            thClass: "text-uppercase align-middle",

            filterOptions: {
              enabled: false,
              placeholder: "TRANSIT PORT",
            },
          },
          {
            thClass: "text-uppercase align-middle",
            label: "Action",
            tdClass: "align-middle text-center",

            field: "action",
          },
        ],
      },
    };
  },
  created() {
    this.$store.dispatch("masterData/FETCH_ALL");
  },
  computed: {
    ...mapState("masterData", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
      "vessel",
      "locations",
    ]),
  },
  methods: {
    onUserBooking(row) {
      // console.log(row)
      this.modalShow = true;
      this.request_quotation.service_type = row.service_type_id;
      this.request_quotation.eta = row.eta;
      this.request_quotation.etd = row.etd;
      this.request_quotation.pol_port = row.pol_code;
      this.request_quotation.pod_port = row.pod_code;
      this.request_quotation.cargo_ready = moment().format("DD/MM/YY HH:mm");
      this.request_quotation.shipping_line = row.carrier_id;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    onHandlerBooking(payload) {
      // console.log('--- row ---', payload.row);
      this.valueModal = true;
      this.currentItem = payload.row;
    },
    async getSchedule() {
      var validate = await this.$refs.simpleRules.validate().then((success) => {
        return success;
      });
      if (validate) {
        this.$loading.show();
        if (this.schedule_selected == "AIR") {
          this.fields = this.fields_all.AIR;
        } else if (
          this.schedule_selected == "SEA" &&
          this.services_selected == "LCL"
        ) {
          this.fields = this.fields_all.SEA_LTL;
        } else if (
          this.schedule_selected == "SEA" &&
          this.services_selected == "FCL"
        ) {
          this.fields = this.fields_all.FCL;
        } else if (
          this.schedule_selected == "DOMESTIC" &&
          this.services_selected == "FTL"
        ) {
          this.fields = this.fields_all.FTL;
        } else if (
          this.schedule_selected == "DOMESTIC" &&
          this.services_selected == "LTL"
        ) {
          this.fields = this.fields_all.LTL;
        }

        useJwt
          .get(`scheduleList`, {
            params: {
              search: {
                service_type: this.constantsType[this.services_selected],
                eta: this.columnFilters.eta,
                etd: this.columnFilters.etd,
                pol: this.columnFilters.pol,
                pod: this.columnFilters.pod,
                from_date: this.columnFilters?.from_date || "",
                to_date: this.columnFilters?.to_date || "",
              },
              page: 1,
              pageSize: 10000000,
            },
          })
          .then((response) => {
            const data = response.data.result;
            if (!!this.userData) {
              /*this.fields.push({
                key: "actions",
                label: "Actions",
                class: "text-center",
              });*/
              const mapData = data.map((obj) => {
                obj.actions = "/admin/find-a-quotation";
                return obj;
              });
              this.schedule_list = mapData;
              return;
            }
            this.schedule_list = data;
          })
          .finally(() => this.$loading.hide());
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            text: "The field is required",
            icon: "XIcon",
            variant: "warning",
          },
        });
        return;
      }
    },
    async handSubmitModal() {
      var validate = await this.$refs.simpleRulesModal
        .validate()
        .then((success) => {
          return success;
        });
      if (validate) {
        switch (this.selected_radios) {
          case 1:
            if (
              this.userData.userType ==
                this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
              this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin
            ) {
              this.$router.push("/admin/my-quotation");
            } else {
              this.$router.push("/user/my-quotation");
            }
            break;
          default:
            if (
              this.userData.userType ==
                this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
              this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin
            ) {
              this.$router.push("/admin/my-quotation");
            } else {
              this.$router.push("/user/my-quotation");
            }
            break;
        }
      }
    },
  },
  mounted() {},
  watch: {
    schedule_selected() {
      // useJwt
      //   .get(`prepare-check-schedule?type=${this.schedule_selected}`, {})
      //   .then((response) => {
      //     const dataPolList = response.data.result.polList;
      //     const dataPodList = response.data.result.podList;
      //     const mapPolList = dataPolList.map((obj) => {
      //       obj.text = obj.text || obj.portName;
      //       obj.id = obj.id || obj.portCode;
      //       return obj;
      //     });
      //     const mapPodList = dataPodList.map((obj) => {
      //       obj.text = obj.text || obj.portName;
      //       obj.id = obj.id || obj.portCode;
      //       return obj;
      //     });
      //     this.polList = mapPolList;
      //     this.podList = mapPodList;
      //   });

      if (this.schedule_selected) this.services = [];
      this.services.push(...this.services_options[this.schedule_selected]);

      this.schedule_selected == "AIR" ? (this.services_selected = "AIR") : "";
    },
  },
};
</script>
<style>
.select2-selection--single {
  border: 1px solid #2b938c;
  border-radius: 1.5rem;
}

.select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    center / contain no-repeat;
}

.select2-selection__arrow {
  background: none;
  display: none !important;
}

@media (max-width: 865px) {
  .table-responsive-sm {
    overflow: hidden;
    overflow-x: scroll;
  }

  .card {
    overflow: hidden;
  }
}

.has-error .select2-selection {
  border-color: red !important;
}

.schedule .vue-dropzone > .dz-preview .dz-details {
  background: #2b938c;
}

.schedule .dropzone {
  border: 1px solid #2b938c;
  border-radius: 1.5rem;
}

.schedule .select2-selection--single {
  border: 1px solid #2b938c;
}

.schedule .select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    center / contain no-repeat;
}

.schedule .select2-selection__arrow {
  background: none;
  display: none !important;
}

.vgt-table td,
.vgt-table th {
  vertical-align: middle !important;
  font-size: 1rem;
}

.vgt-table th {
  text-align: center;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.border-dr-top {
  border-top: 1px solid #e6e6e6;
}
</style>
